import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { BulkEditProgressOverlayComponent } from "./bulk-edit-progress-overlay.component";

@NgModule({
	declarations: [BulkEditProgressOverlayComponent],
	imports: [CommonModule, MaterialModule, TranslateModule],
	exports: [BulkEditProgressOverlayComponent],
})
export class BulkEditProgressOverlayModule {}
